import { actionCreatorFactory } from 'typescript-fsa';
import { IAuthStore } from './auth.interface';

export namespace AuthAction {
  const actionCreator = actionCreatorFactory('Auth');

  type IAuthResponse = Pick<IAuthStore, 'apiToken' | 'apiTokenParsed' | 'idTokenParsed' | 'excludedScope'>;

  export const login = actionCreator('LOGIN');
  export const loginDone = actionCreator<IAuthResponse>('LOGIN_DONE');
  export const logout = actionCreator('LOGOUT');

  export const failed = actionCreator<{ error: string }>('FAILED');

  export const destroy = actionCreator('DESTROY');
}
